import { useStaticQuery, graphql } from 'gatsby';

const useHeaderQuery = () => {
	const data = useStaticQuery(graphql`
		query GET_HEADER_DATA {
			wp {
				acfOptionsHeader {
					acfHeaderSettings {
						header {
							banner {
								items {
									bannerContent
								  	tag
								  	title
								  	image {
										altText
										localFile {
									  		childImageSharp {
												gatsbyImageData(layout: FULL_WIDTH)
									  		}
										}
								  	}
								  	description
								  	link {
										label
										url
								  	}
								}
							}
							navigationText
							navigationItems {
								label
								optionalUrl
								dropdown {
									column {
										type
										featuredColumn {
											link {
												label
												url
											}
											image {
												altText
												sourceUrl
											}
										}
										listColumn {
											link {
												label
												url
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	`);

	return data;
};

export default useHeaderQuery;
